import { useState } from "react";
import { api } from "../api/client.js";
import { getAdminToken } from "./auth.js";

const formatDate = (value) =>
  value
    ? new Intl.DateTimeFormat("en", { dateStyle: "medium" }).format(
        new Date(value),
      )
    : "Not specified";

export default function ReservationManager({
  reservations,
  onChanged,
  onUnauthorized,
}) {
  const [deletingId, setDeletingId] = useState("");
  const [error, setError] = useState("");

  const removeReservation = async (reservation) => {
    if (deletingId) return;
    const confirmed = window.confirm(
      `Delete the reservation from ${reservation.name}? This cannot be undone.`,
    );
    if (!confirmed) return;

    setDeletingId(reservation.id);
    setError("");
    try {
      await api.admin.reservations.remove(reservation.id, getAdminToken());
      await onChanged();
    } catch (requestError) {
      if (requestError.status === 401 || requestError.status === 403) {
        onUnauthorized();
        return;
      }
      setError(requestError.message || "Could not delete the reservation");
    } finally {
      setDeletingId("");
    }
  };

  return (
    <section className="admin-panel">
      <div className="admin-panel-heading">
        <div>
          <p className="admin-eyebrow">Customer requests</p>
          <h2>Reservations</h2>
        </div>
      </div>

      {error && (
        <p className="admin-form-error" role="alert">
          {error}
        </p>
      )}

      <div className="admin-table-wrap">
        <table>
          <thead>
            <tr>
              <th>Customer</th>
              <th>Phone number</th>
              <th>Occasion</th>
              <th>Address</th>
              <th>Preferred date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {reservations.map((reservation) => (
              <tr key={reservation.id}>
                <td>
                  {reservation.name}
                  <small>
                    <a href={`mailto:${reservation.email}`}>
                      {reservation.email}
                    </a>
                  </small>
                </td>
                <td>
                  <a
                    className="admin-contact-link"
                    href={`tel:${reservation.phone.replace(/[^\d+]/g, "")}`}
                  >
                    {reservation.phone}
                  </a>
                </td>
                <td>{reservation.occasion || "Not specified"}</td>
                <td>{reservation.address || "Not specified"}</td>
                <td>{formatDate(reservation.preferredDate)}</td>
                <td>
                  <button
                    type="button"
                    className="admin-delete"
                    onClick={() => removeReservation(reservation)}
                    disabled={Boolean(deletingId)}
                  >
                    {deletingId === reservation.id ? "Deleting..." : "Delete"}
                  </button>
                </td>
              </tr>
            ))}
            {reservations.length === 0 && (
              <tr>
                <td style={{ color: "#667085" }} colSpan="6">
                  No reservations yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
